// Briefe per Post (E-POST) an diesen Mieter.
import { BriefVerlauf } from '../../../dokumente/post/BriefVerlauf';
import { useMieterSeite } from '../MieterSeitenKontext';

export function BriefePanel() {
  const m = useMieterSeite().daten.mieter;
  const name = [m.vorname, m.nachname].filter(Boolean).join(' ') || m.firma_name || 'Mieter';
  return <BriefVerlauf art="mieter" id={m.id} name={name} />;
}
